import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import { colors } from "../_variables";
import { lenis } from "../_common/smooth-scroll";
import canvas from "./canvas";

gsap.registerPlugin(SplitText);

export default function opening() {
  const target = document.querySelector(".splash");

  if (!target) return;

  const flag = sessionStorage.getItem("visted");

  if (!flag) {
    lenis.isLocked = true;

    const canvasAnimation = canvas();

    const tl = gsap.timeline();
    tl.add(splash());
    tl.add(kv(), "-=0.6");
    tl.add(
      gsap.timeline().set(".splash", {
        autoAlpha: 0,
        onComplete: () => {
          canvasAnimation.destroy();
        },
      })
    );
  } else {
    visitedAnimation();
  }

  function kv() {
    const main = SplitText.create(".section-kv .catch__main", {
      type: "chars",
    });
    const sub = SplitText.create(".section-kv .catch__sub", {
      type: "chars",
    });

    main.chars.forEach((char, i) => {
      gsap.set(char, { color: colors[i % 7] });
    });
    sub.chars.forEach((char, i) => {
      gsap.set(char, { color: colors[i % 7] });
    });

    return (
      gsap
        .timeline()
        .from(
          main.chars,
          {
            autoAlpha: 0,
            duration: 0.2,
            ease: "none",
            stagger: {
              amount: 0.4,
            },
          },
          "<"
        )
        .to(
          main.chars,
          {
            color: "#262626",
            duration: 0.2,
            ease: "none",
            stagger: {
              amount: 0.4,
            },
            onComplete: () => {
              lenis.isLocked = false;
            },
          },
          "<0.3"
        )
        .from(
          sub.chars,
          {
            autoAlpha: 0,
            duration: 0.2,
            ease: "none",
            stagger: {
              amount: 0.5,
            },
          },
          "<"
        )
        .to(
          sub.chars,
          {
            color: "#ffffff",
            duration: 0.2,
            ease: "none",
            stagger: {
              amount: 0.5,
            },
          },
          "<0.3"
        )
        // .from(
        //   ".site-bg .site-bg__kv",
        //   { filter: "grayscale(0.6)", duration: 1, ease: "none" },
        //   "<-0.3"
        // )
        .from(
          ".site-header .masthead, .site-header .global-nav",
          {
            y: -100,
            autoAlpha: 0,
            ease: "expo.out",
            duration: 1.2,
          },
          "<0.3"
        )
        .from(
          ".section-kv #scroll-indicator_kv",
          {
            xPercent: -100,
            autoAlpha: 0,
            ease: "expo.out",
            duration: 1.2,
          },
          "<0.3"
        )
    );
  }

  function visitedAnimation() {
    const main = SplitText.create(".section-kv .catch__main", {
      type: "chars",
    });
    const sub = SplitText.create(".section-kv .catch__sub", {
      type: "chars",
    });

    main.chars.forEach((char, i) => {
      gsap.set(char, { color: colors[i % 7] });
    });
    sub.chars.forEach((char, i) => {
      gsap.set(char, { color: colors[i % 7] });
    });

    return gsap
      .timeline()
      .set(".splash", { autoAlpha: 0 })
      .from(
        main.chars,
        {
          autoAlpha: 0,
          duration: 0.2,
          ease: "none",
          stagger: {
            amount: 0.4,
          },
        },
        "<"
      )
      .to(
        main.chars,
        {
          color: "#262626",
          duration: 0.2,
          ease: "none",
          stagger: {
            amount: 0.4,
          },
          onComplete: () => {
            lenis.isLocked = false;
          },
        },
        "<0.3"
      )
      .from(
        sub.chars,
        {
          autoAlpha: 0,
          duration: 0.2,
          ease: "none",
          stagger: {
            amount: 0.5,
          },
        },
        "<"
      )
      .to(
        sub.chars,
        {
          color: "#ffffff",
          duration: 0.2,
          ease: "none",
          stagger: {
            amount: 0.5,
          },
        },
        "<0.3"
      );
  }

  function splash() {
    return gsap
      .timeline()
      .to(".rect-left .line-h", {
        xPercent: 100,
        duration: 0.8,
        ease: "expo.in",
      })
      .to(
        ".rect-right .line-h",
        {
          xPercent: -100,
          duration: 0.8,
          ease: "expo.in",
        },
        "<"
      )
      .to(".rect-left .line-v", {
        yPercent: 100,
        duration: 0.8,
        ease: "expo.out",
      })
      .to(
        ".rect-right .line-v",
        {
          yPercent: -100,
          duration: 0.8,
          ease: "expo.out",
        },
        "<"
      )
      .to(
        ".splash__logo svg #mask-path",
        {
          strokeDashoffset: 434,
          duration: 1.4,
          ease: "expo.out",
        },
        "<"
      )
      .to(
        ".splash__logo svg #C, .splash__logo svg #O1, .splash__logo svg #O2, .splash__logo svg #R, .splash__logo svg #S",
        {
          clipPath: "inset(0% 0 0% 0)",
          duration: 0.6,
          ease: "expo.out",
          stagger: 0.1,
        },
        "<"
      )
      .fromTo(
        ".splash__logo svg #C, .splash__logo svg #O1, .splash__logo svg #O2, .splash__logo svg #R, .splash__logo svg #S",
        { yPercent: 100 },
        {
          yPercent: 0,
          duration: 0.6,
          ease: "expo.out",
          stagger: 0.1,
        },
        "<"
      )
      .to(
        ".splash__logo svg #C, .splash__logo svg #O1, .splash__logo svg #O2, .splash__logo svg #R, .splash__logo svg #S",
        {
          clipPath: "inset(100% 0 0% 0)",
          yPercent: -100,
          duration: 0.4,
          ease: "expo.in",
          stagger: 0.1,
        },
        "+=0.6"
      )
      .to(
        ".splash__logo svg #mask-path",
        {
          strokeDashoffset: 217,
          duration: 1,
          ease: "expo.in",
        },
        "<"
      )
      .to(
        ".rect-left .line-h",
        {
          xPercent: 200,
          duration: 0.8,
          ease: "expo.in",
        },
        "<0.2"
      )
      .to(
        ".rect-right .line-h",
        {
          xPercent: -200,
          duration: 0.8,
          ease: "expo.in",
        },
        "<"
      )
      .to(
        ".rect-left .line-v",
        {
          yPercent: 200,
          duration: 0.2,
          ease: "none",
        },
        "<0.8"
      )
      .to(
        ".rect-right .line-v",
        {
          yPercent: -200,
          duration: 0.2,
          ease: "none",
        },
        "<"
      )
      .to(
        ".splash__bg",
        {
          autoAlpha: 0,
          duration: 1.5,
          ease: "none",
          onComplete: () => {
            sessionStorage.setItem("visted", "true");
          },
        },
        "<-0.4"
      )
      .set(".splash", { autoAlpha: 0 });
  }
}
